import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { CampaignFilterRequest } from '../../../campaign/campaign.model';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { CampaignFilterService } from '../../../campaign/campaign-filter.service';
import { MatButtonModule } from '@angular/material/button';

import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationDialogComponent } from '../../../shared/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-save-filter-dialog',
  imports: [MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, TranslateModule],
  templateUrl: './save-filter-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './save-filter-dialog.component.scss',
})
export class SaveFilterDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public campaignFilterRequest: CampaignFilterRequest,
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    private campaignFilterService: CampaignFilterService,
  ) {}

  ngOnInit(): void {
    this.name = this.campaignFilterRequest.name;
  }

  public name: string;

  clickCancel() {
    this.dialogRef.close(false);
  }

  clickSave() {
    this.campaignFilterRequest.name = this.name;
    this.dialogRef.close(true);
  }
}
